<template>
  <div>
    <div>
      <div class="my-3 d-flex justify-content-baseline align-items-center">
        <h6 class="mb-0 mr-3">เลือกผู้เรียนจำนวน {{ checkedCount }} คน</h6>
        <div>
          <b-dropdown text="เลือกตัวเลือก">
            <div v-for="(status, index) in statusList" :key="index">
              <b-dropdown-item @click="selectStudentstatus(status)">
                {{ status.text }}
              </b-dropdown-item>
            </div>
          </b-dropdown>
        </div>
      </div>
      <div class="w-auto">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th
                        class="align-middle"
                        style="padding-left: 0.75rem !important; width: 200px; padding-top: 10px !important; padding-bottom: 10px !important;"
                    >
                        <div class="d-flex justify-content-baseline">
                          <b-form-checkbox v-model="selectAllStudent" @change="toggleAll">
                          </b-form-checkbox>
                          <img style="cursor: pointer;" @click="toggleSort('mp_firstName')" :src="srcImage" alt="SVG Image" />
                          <div class="ml-2">
                            ชื่อผู้เรียน
                          </div>
                        </div>
                    </th>
                    <th
                        class="align-middle"
                        style="padding-left: 0.75rem !important; width: 200px;"
                    >
                        <img
                            style="cursor: pointer;"
                            @click="toggleSort('m_email')"
                            :src="srcImage"
                            alt="SVG Image"
                        />
                        อีเมล
                    </th>
                    <th class="text-center align-middle" style="width: 70px;">
                        เข้าสอบ
                    </th>
                    <th class="text-center align-middle" style="width: 70px;">
                        ไม่เข้าสอบ
                    </th>
                    <th class="text-center align-middle" style="width: 100px;">
                        คะแนน
                    </th>
                    <th class="text-center align-middle" style="width: 100px;">
                        เปอร์เซ็นต์
                    </th>
                </tr>
            </thead>
            <!-- tbody -->
            <tbody id="table-body">
                <tr v-for="(item, index) in memberEnroll" :key="index">
                    <td>
                        <b-form-checkbox
                          v-model="selected[item.cer_id]"
                          :key="item.cer_id"
                          @change="toggleSelectAllStudent"
                        >
                            {{ item.mp_firstName + " " + item.mp_lastName }}
                        </b-form-checkbox>
                    </td>
                    <td>{{ item.m_email }}</td>
                    <td class="text-center">
                        <b-form-radio
                        v-model="selectStatus[index]"
                        @change="updateStatus(index, 'PRESENT')"
                        :disabled="!isEditAble"
                        value="PRESENT"
                        ></b-form-radio>
                    </td>
                    <td class="text-center">
                        <b-form-radio
                        v-model="selectStatus[index]"
                        @change="updateStatus(index, 'ABSENT')"
                        :disabled="!isEditAble"
                        value="ABSENT"
                        ></b-form-radio>
                    </td>
                    <td class="text-center">
                      <b-form-input
                        type="text"
                        :disabled="selectStatus[index] !== 'PRESENT' || !isEditAble"
                        placeholder="-"
                        v-model="item.lel_examResultScore"
                        @input="onScoreInput(index, $event)"
                        @keypress="onScoreKeypress($event, item.lel_examResultScore)"
                        :class="{ 'is-invalid': errors.includes(index) }"
                      ></b-form-input>
                    </td>
                    <td class="d-flex">
                          <div class="input-group">
                              <b-form-input
                                type="text"
                                class="form-control"
                                style="width: 40px;"
                                :disabled="selectStatus[index] !== 'PRESENT' || !isEditAble"
                                placeholder="-"
                                v-model="item.lel_examResultPercent"
                                @input="onPercentInput(index, $event)"
                                @keypress="onScoreKeypress($event, item.lel_examResultPercent)"
                                :class="{ 'is-invalid': errors.includes(index) }"
                                
                              />
                              <div class="input-group-prepend">
                                  <span class="input-group-text" style="border-top-right-radius: 0.25rem; border-bottom-right-radius: 0.25rem;">
                                      %
                                  </span>
                              </div>
                          </div>
                    </td>
                </tr>
            </tbody>
        </table>
      </div>
      <br />
      <br />
      <div class="submit-btn" v-if="isEditAble">
        <b-button
          class="ml-2"
          variant="primary"
          @click="onSave()"
          :disabled="errors.length != 0"
          >บันทึก</b-button
        >
      </div>
    </div>

    <ConfirmSuccessModal
      :title="'เพิ่มข้อมูลการเข้าชั้นเรียนสำเร็จ'"
      :show="isShowSuccessModal"
      @success="success()"
    />
    <WarningActionModal
      :show="isConfirmStatus"
      :title="'ยืนยันสถานะการเข้าสอบหรือไม่?'"
      :detail="
        `ต้องการเลือกสถานะ${studentStatus.text} ให้ผู้เรียนที่ถูกเลือกหรือไม่`
      "
      :actionName="'ยืนยัน'"
      :showConfirmModal="isShowConfirmStatusModal"
      :successTitle="'ยืนยันสถานะการเข้าเรียนสำเร็จ'"
      @canceled="isConfirmStatus = false"
      @action="addStudentstatus()"
      @onSuccess="isShowConfirmStatusModal = false"
    />
  </div>
</template>

<script>
import Vue from "vue";
import ConfirmSuccessModal from "../attendance/modal/ConfirmSuccessModal.vue";
import WarningActionModal from "../attendance/modal/WarningActionAttendanceModal.vue";
import api from "@/services/api.js";

export default {
  name: "editExamAttendance",
  components: { ConfirmSuccessModal, WarningActionModal },
  props: {
    courseId: {
      type: Number,
    },
    memberEnroll: {
      type: Array,
    },
    maxScore: {
      type: Number,
    },
    isEditAble: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      statusList: [
        { text: "เข้าสอบ", value: "PRESENT" },
        { text: "ไม่เข้าสอบ", value: "ABSENT" },
      ],
      srcImage:
        "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='15' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e",
      selected: {},
      selectAllStudent: false,
      selectStatus: [],

      sortBy: "",
      sortDesc: false,

      studentStatus: {},
      isConfirmStatus: false,
      isShowConfirmStatusModal: false,
      isShowSuccessModal: false,

      errors: [],
    };
  },
  watch: {
    sortBy: "sortData",
    sortDesc: "sortData",
  },
  computed: {
    checkedCount() {
        // Use Object.values to get an array of checkbox values (true/false).
        const checkboxValues = Object.values(this.selected);
        const checkedCount = checkboxValues.filter((value) => value === true)
            .length;
        return checkedCount;
    },
  },
  mounted() {
    this.selectStatus = this.memberEnroll.map(item => 
      item.lel_examResultScore != null ? 'PRESENT' : 'ABSENT'
    );
  },
  methods: {
    sortData() {
      const column = this.sortBy;
      const desc = this.sortDesc ? -1 : 1;

      // Use JavaScript's Array.sort() method to sort the data
      this.memberEnroll.sort((a, b) => {
        const aValue = a[column];
        const bValue = b[column];

        return aValue.localeCompare(bValue) * desc;
      });
    },
    toggleAll() {
      if (this.selectAllStudent) {
        // If selectAllStudent is true, set all items to true
        this.memberEnroll.forEach((item) => {
          Vue.set(this.selected, item.cer_id, true);
        });
      } else {
        // If selectAllStudent is false, set all items to false
        this.memberEnroll.forEach((item) => {
          Vue.set(this.selected, item.cer_id, false);
        });
      }
    },
    toggleSelectAllStudent() {
        const itemLength = this.memberEnroll.length;
        const checkboxLength = Object.keys(this.selected).length;
        const allChecked = Object.values(this.selected).every((value) => value);

        if (itemLength === checkboxLength && allChecked) {
            this.selectAllStudent = true;
        } else {
            this.selectAllStudent = false;
        }
    },
    toggleSort(column) {
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc; // Toggle sort direction
      } else {
        this.sortBy = column; // Set the new column to sort by
        this.sortDesc = false; // Default to ascending order
      }
    },
    selectStudentstatus(status) {
        this.studentStatus = status;
        this.isConfirmStatus = true;
    },
    addStudentstatus() {
      this.memberEnroll.forEach((item, index) => {
        if (this.selected[item.cer_id]) {
          var status = this.studentStatus.value;
          Vue.set(this.selectStatus, index, status);
          this.updateStatus(index, status) 
          this.selected[item.cer_id] = false;

          if (this.selectAllStudent === true) {
            this.selectAllStudent = false;
          }
        }
      });
      this.isConfirmStatus = false;
    },
    updateDefaultScore() {
      this.selectStatus.forEach((item, index) => {
        if (this.memberEnroll[index].lel_examResultPercent == null) {
          this.memberEnroll[index].lel_examResultPercent = 0
          this.memberEnroll[index].lel_examResultScore = 0
        }
      })
    },
    updateStatus(index, status) {
      if (status === 'PRESENT') {
        this.$set(this.memberEnroll[index], 'lel_examResultScore', 0);
        this.$set(this.memberEnroll[index], 'lel_examResultPercent', 0);
      } else {
        this.$set(this.memberEnroll[index], 'lel_examResultScore', null);
        this.$set(this.memberEnroll[index], 'lel_examResultPercent', null);
      }
    },
    cleanNumericInput(value) {
      // Remove all non-digit and non-dot characters
      let clean = value.replace(/[^0-9.]/g, '');

      // Allow only one dot
      const parts = clean.split('.');
      if (parts.length > 2) {
        clean = parts[0] + '.' + parts[1];
      }

      return clean;
    },
    onScoreKeypress(e, currentValue) {
      if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
        return;
      }

      if (!/[0-9.]/.test(e.key)) {
        e.preventDefault();
        return;
      }

      if (e.key === '.' && currentValue.includes('.')) {
        e.preventDefault();
        return;
      }

    },
    onScoreInput(index, value) {
      value = this.cleanNumericInput(value);

      if (parseFloat(value) > this.maxScore){
        if (!this.errors.includes(index)) {
          this.errors.push(index);
        }
      } else {
        this.errors = this.errors.filter((errorIndex) => errorIndex !== index);
      }


      this.$set(this.memberEnroll[index], 'lel_examResultScore', value);

      if (value !== '') {
        this.memberEnroll[index].lel_examResultPercent = Number(((parseFloat(value) / this.maxScore) * 100).toFixed(2));
      } else {
        this.memberEnroll[index].lel_examResultPercent = null;
      }
    },
    onPercentInput(index, value) {
      value = this.cleanNumericInput(value);
      this.memberEnroll[index].lel_examResultPercent = value;

      if (parseFloat(value) > 100) {
        if (!this.errors.includes(index)) {
          this.errors.push(index);
        }
      } else {
        this.errors = this.errors.filter((errorIndex) => errorIndex !== index);
      }

      this.$set(this.memberEnroll[index], 'lel_examResultPercent', value);

      if (value !== '') {
        this.memberEnroll[index].lel_examResultScore = Number(((parseFloat(value) / 100) * this.maxScore).toFixed(2));
      } else {
        this.memberEnroll[index].lel_examResultScore = null;
      }
    },
    async onSave() {
      await api.put(`/v1/exam-attendance`, {
        data: this.memberEnroll,
      });
      this.isShowSuccessModal = true;
    },
    success() {
      this.isShowSuccessModal = false;
    }
  },
};
</script>

<style scoped>
.table th {
  padding: 0.1rem !important;
}
.table tbody td {
  vertical-align: middle;
  padding: 0.4rem 0.75rem 0.4rem !important;
}
.submit-btn {
  display: flex;
  justify-content: flex-end;
}
</style>
